/**
 * Single place for translation key lookup. Splits key by `.` or `_` and walks the object.
 * Returns the string value or null if not found.
 */
export function getTranslationByKey(
	obj: Record<string, unknown> | null | undefined,
	keyString: string,
): string | null {
	if (!obj || typeof obj !== 'object') return null;
	const keys = keyString.split(/[._]/);
	const value = keys.reduce<unknown>((acc, translationKey) => {
		if (acc && typeof acc === 'object' && translationKey in acc) {
			return (acc as Record<string, unknown>)[translationKey];
		}
		return null;
	}, obj);
	return typeof value === 'string' ? value : null;
}
